import './option.scss'
import * as React from 'react'
import * as ReactGA from 'react-ga'

import { Voting, ModalState } from '../common/voting/voting'
import { GlobalEnv, Env } from '../../utils/env'
import { defaultAppFn, IShare } from '../../utils/app'
import { Observer } from '../../utils/rx'

import { TabBar } from '../common/tab_bar/tab_bar'
import { Link } from 'react-navi'

import { WXShareConfig } from 'src/utils/config'
import { Api } from './api'

const divStyle = {
    display: 'none'
}
interface IProps {
    id: string
    option: string
}

interface IState {
    img: string
    name: string
    shortName: string
    descript: string
    groupID: string
    shopURL: string
    nextURL: string
    voteNum: number
    remaining: boolean
    url: string
    coverImage: string
}

class OptionDetail extends React.Component<IProps, IState>{
    public ops: boolean = false
    public state = {
        img: '',
        name: '',
        shortName: '',
        descript: '',
        groupID: '',
        shopURL: '',
        nextURL: '',
        voteNum: 0,
        remaining: true,
        url: '',
        coverImage: ''
    }

    public componentDidMount = () => {
        // 监听app分享
        Observer.subscribe('share', async () => {
            const nickname = await this.getShareNick()
            const share: IShare = {
                title: `${nickname}邀请您投票，${this.state.shortName || this.state.name}快来投我一票`,
                content: this.state.descript,
                image: this.state.url || this.state.coverImage,
                url: window.location.href
            }
            defaultAppFn.Apply('app_share', share)
        })
        ReactGA.pageview(window.location.pathname + window.location.search)
    }

    public componentWillUnmount = () => {
        Observer.unSubscribe('share')
    }

    public voting(res: any, state: ModalState) {
        if (state === ModalState.Voting) {
            this.ops = true
        }
        if (res.options && res.options.length === 1) {
            const option = res.options[0]
            defaultAppFn.Apply('app_nav', {
                show: true,
                back: true,
                title: option.name,
                share: true
            })
            this.setState({
                img: option.url,
                name: option.name,
                shortName: option.short_name,
                descript: option.description,
                groupID: res.group_id,
                shopURL: GlobalEnv === Env.App ? option.app_url : option.shop_url,
                nextURL: res.redirect_url,
                voteNum: option.vote_num,
                remaining: res.max_num - res.voted_num > 0,
                url: option.url,
                coverImage: res.cover_image
            }, () => {
                // 微信分享设置
                WXShareConfig(
                    res.group_name?`我正在参加《${res.group_name}》，快来投我一票`:`我正在参加上海有色网投票评选，快来投我一票`,
                    option.description,
                    window.location.href,
                    res.share_picture_url
                )
                this.setState({
                    groupID: res.group_id,
                })
            })
        }
    }

    public render() {
        return (
            <div className="OptionWrap">
                <div className="OptionImg">
                    <Link href={this.state.shopURL}>
                        <img src={this.state.img} alt="" />
                    </Link>
                </div>
                <div className="OptionName">
                    <span>{this.state.name}</span>
                </div>
                <div className="OptionDetail">
                    {this.state.descript}
                </div>
                <div style={(!this.state.remaining && this.ops) ? divStyle : {}}>
                    <div className="OptionVoting">
                        <Voting
                            NECaptchaKey="option-detail"
                            voteID={this.props.id}
                            optionID={this.props.option}
                            moreUrl={this.state.nextURL ? this.state.nextURL : `/group/${this.state.groupID}/detail/${this.props.id}`}
                            shopUrl={this.state.shopURL}
                            success={(res, state) => { this.voting(res, state) }}
                        />
                    </div>
                </div>


                <div style={(!this.state.remaining && this.ops) ? {} : divStyle} className="OptionSuccess">
                    <div className="vote-suc">投票成功</div>
                    <div className="has-vote">当前票数&nbsp;{this.state.voteNum}</div>
                    <Link href={this.state.nextURL ? this.state.nextURL : `/group/${this.state.groupID}/detail/${this.props.id}`}>
                        <div className="watch-more" >查看更多精彩</div>
                    </Link>
                    <a style={this.state.shopURL ? {} : divStyle} href={this.state.shopURL} className="turn-shop">进入企点店铺了解更多</a>
                </div>

                <TabBar data={{
                    groupId: this.state.groupID,
                    activityId: this.props.id,
                    currentText: ''
                }} />
            </div>
        )
    }

    private getShareNick = (): Promise<string> => {
        return new Promise(resolve => {
            let nickname: string = ''
            Api.getShareNick().then(res => {
                if (res.code === 0 && res.data) {
                    nickname = res.data.nick
                }
                resolve(nickname)
            })
        })
    }
}

export {
    OptionDetail
}


// WEBPACK FOOTER //
// ./src/components/activity_option_detail/option.tsx